import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MaskOptions } from '../../models/form-input';

@Component({
  selector: 'readonly',
  templateUrl: './readonly.component.html',
  styleUrls: ['./readonly.component.scss']
})
export class ReadonlyComponent implements OnInit {

  @Input() id!: string;
  @Input() formGroup!: FormGroup;
  @Input() placeholder!: string;
  @Input() label!: string;
  @Input() maskOptions!: MaskOptions;

  constructor() { }

  ngOnInit(): void {
  }

}
